/** Stockage local INBOX : 200 derniers mails en .eml (FIFO — le 201ᵉ sort du stockage). */
export const MAIL_STORAGE_INBOX_MAX = 200;

/** Quota logique stockage local navigateur (aligné serveur 2 Go). */
export const MAIL_STORAGE_MAX_BYTES = 2 * 1024 * 1024 * 1024;

/** Téléchargements .eml simultanés max par vague (fallback sans worker). */
export const MAIL_STORAGE_FETCH_BATCH = 1;

/** Délai avant archivage INBOX auto (laisser la liste / IMAP respirer). */
export const MAIL_STORAGE_INBOX_SYNC_DEFER_MS = 8_000;

/** Pause entre vagues fetch .eml (ms) — évite tempête Apache partagé. */
export const MAIL_STORAGE_FETCH_GAP_MS = 2_000;

/** Poll progression archivage worker (ms). */
export const MAIL_STORAGE_WORKER_POLL_MS = 2_000;

/** Re-kick worker si pas de progrès (ms) — aligné cron (~1 min), pas de tempête Apache. */
export const MAIL_STORAGE_WORKER_STALE_MS = 60_000;

/** Bascule fetch-eml client si le worker n'avance plus (cron/daemon absent). */
export const MAIL_STORAGE_WORKER_MAX_STALE_KICKS = 3;

/** Réception considérée à jour si ≤ N UID manquants et couverture ≥ seuil (ex. 199/200). */
export const MAIL_STORAGE_INBOX_ARCHIVE_DONE_MISSING_MAX = 2;
export const MAIL_STORAGE_INBOX_ARCHIVE_DONE_COVERAGE_MIN = 98;

/** Timeout HTTP fetch-eml (fallback client sans worker). */
export const MAIL_STORAGE_FETCH_TIMEOUT_MS = 120_000;

/** Préparation cache PJ preview par vague (rattrapage après archivage .eml). */
export const MAIL_STORAGE_ATTACHMENT_WARM_BATCH = 5;

/** Prefetch auto en-têtes tous dossiers — désactivé (stockage manuel). */
export const MAIL_AUTO_FOLDER_PREFETCH_ENABLED = false;

/** Téléchargement manuel dossier : minimum / maximum / défaut. */
export const MAIL_STORAGE_FOLDER_MIN = 10;
export const MAIL_STORAGE_FOLDER_MAX = 50;
export const MAIL_STORAGE_FOLDER_DEFAULT = 25;
